import type { IntlShape } from "react-intl";
import store from "../../../../../../store/store";
export class GetSortingTranslationsHelper {
  //
  static getSortingTranslations(intl: IntlShape) {
    const sortingOptions = [
      {
        value: "popular",
        label: intl.formatMessage({
          id: "global-events-navigation-popular",
        }),
      },
      {
        value: "date",
        label: intl.formatMessage({
          id: "global-events-navigation-date",
        }),
      },
    ];
    // Update the Competition List store with sortingOptions
    store.dispatch.competitionListModel.setSortingOptions({
      sortingOptions,
    });
  }
}
